import { Spacer, Text } from '@oy/ui';
import { Colors, FontStyleEnums } from '@oy/uicore';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import React from 'react';
import IconButton from './IconButton/IconButton';
import styles from './InputChip.module.css';

export type InputChipProps = {
  title: string;
  description?: string;
  isDisabled?: boolean;
  onClose?: () => void;
  className?: string;
  chipTextStyle?: FontStyleEnums;
  deleteDisabled?: boolean;
  draggable?: boolean;
};

const InputChip = ({
  title,
  description = '',
  isDisabled = false,
  onClose,
  className = '',
  chipTextStyle = Text.Style.BodyMdRegular,
  deleteDisabled = false,
  draggable = false,
}: InputChipProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      {draggable && (
        <Spacer
          right={Spacer.Size.XS}
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <SystemIcon color={Colors.BLACK100} name="dot-drag" size={14} />
        </Spacer>
      )}
      <Spacer right={description ? Spacer.Size.XXXS : Spacer.Size.XS}>
        <Text
          textStyle={description ? Text.Style.BodyMdSemibold : chipTextStyle}
          color={isDisabled ? Colors.BLACK40 : Colors.BLACK100}
        >
          {title}
        </Text>
      </Spacer>
      {description ? (
        <Spacer right={Spacer.Size.XS}>
          <Text
            textStyle={Text.Style.BodyMdRegular}
            color={isDisabled ? Colors.BLACK40 : Colors.BLACK100}
            disabled={isDisabled}
          >
            {`(${description})`}
          </Text>
        </Spacer>
      ) : null}
      {!deleteDisabled && (
        <IconButton onClick={onClose} disabled={isDisabled} />
      )}
    </div>
  );
};

export default InputChip;
